// src/components/main/asgSection/WhyOrkestamediaContent.tsx
import React from 'react';
import { Button, Box } from '@mui/material';
import useStyles from './styles';
import whyOrkestamediaImg from '../../../assets/images/gaphs_phone.svg'
const WhyOrkestamediaContent: React.FC = () => {
  const classes = useStyles();

  return (
    <section id="plataforma" className={classes.section}>
      <Box className={classes.textContainer}>
        <Box className={classes.itemContainerLeft}>
          <h1 className={classes.heading}>¿Por qué OrkestaMedia?</h1>
          <Box className={classes.imgTop}>
            <img src={whyOrkestamediaImg} alt="¿Por qué orkestamedia?" />
          </Box>
          <p className={classes.paragraph}>
            Dirige cada inversión publicitaria con la precisión de un maestro. Obtén visibilidad, control y proyecciones precisas para transformar cada campaña en una sinfonía de éxito. ¡Haz que cada nota cuente!
          </p>
          <Button variant="outlined" href='#contacto' className={classes.button}>
            Solicita una demo
          </Button>
        </Box>
        <Box className={classes.itemContainerRight}>
          <img src={whyOrkestamediaImg} alt="¿Por qué orkestamedia?" />
        </Box>
      </Box>
    </section>
  );
};

export default WhyOrkestamediaContent;